import React, { useState } from "react";
import { Card, Typography, Divider, Grid, Box } from "@mui/material";
import PropTypes from "prop-types";
import FormTitle from "../../../FormFields/FormTitle";
import FormFileDrop from "../../../FormFields/FormFileDrop";
import FormTextAreaField from "../../../FormFields/FormTextAreaField";
import { formCardStyle } from '../../../TransitionStyles';
import { DIETARY } from '../../../formQuestionsEnum';
import { FILE_TYPES } from '../../../formFileTypesEnum';

FileUploadForm.propTypes = {
  permissions: PropTypes.object
}

export default function FileUploadForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    DIETARY.DIETARY_STAFFING_SCHEDULE.id,
    DIETARY.FOOD_COMMITTEE_MEETINGS.id,
    DIETARY.COPY_OF_MENUS.id,
    DIETARY.ALTERED_CONSISTENCY_DIETS.id,
    DIETARY.THERAPEUTIC_RESTRICTIONS.id,
    DIETARY.DIETARY_SUPPLEMENTS.id,
  ]

  const showForm = fieldIds.some(id => id in permissions);

  return showForm &&
    <Card sx={formCardStyle}>
      <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
        File upload
      </Typography>
      <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
      <Grid container spacing={1.5}>

        {DIETARY.DIETARY_STAFFING_SCHEDULE.id in permissions && <Grid item xs={12} lg={4}>
          <Box display="flex" flexDirection="column" justifyContent='space-between' height="100%">
            <FormTitle fieldAttributes={{ questionTitle: 'Dietary staffing schedule', fieldType: 'file' }} />
            <FormFileDrop
              fieldName={DIETARY.DIETARY_STAFFING_SCHEDULE.fieldName}
              fieldAttributes={{
                isEditable: permissions[DIETARY.DIETARY_STAFFING_SCHEDULE.id],
                fileTypeId: FILE_TYPES.DIETARY_STAFFING_SCHEDULE,
              }}
            />
          </Box>
        </Grid>}

        {DIETARY.FOOD_COMMITTEE_MEETINGS.id in permissions && <Grid item xs={12} lg={4}>
          <Box display="flex" flexDirection="column" justifyContent='space-between' height="100%">
            <FormTitle fieldAttributes={{ questionTitle: 'Last three food committee meetings', fieldType: 'file' }} />
            <FormFileDrop
              fieldName={DIETARY.FOOD_COMMITTEE_MEETINGS.fieldName}
              fieldAttributes={{
                isEditable: permissions[DIETARY.FOOD_COMMITTEE_MEETINGS.id],
                fileTypeId: FILE_TYPES.FOOD_COMMITTEE_MEETINGS,
              }}
            />
          </Box>
        </Grid>}

        {DIETARY.COPY_OF_MENUS.id in permissions && <Grid item xs={12} lg={4}>
          <Box display="flex" flexDirection="column" justifyContent='space-between' height="100%">
            <FormTitle fieldAttributes={{ questionTitle: 'Copy of menus', fieldType: 'file' }} />
            <FormFileDrop
              fieldName={DIETARY.COPY_OF_MENUS.fieldName}
              fieldAttributes={{
                isEditable: permissions[DIETARY.COPY_OF_MENUS.id],
                fileTypeId: FILE_TYPES.COPY_OF_MENUS,
              }}
            />
          </Box>
        </Grid>}

        {DIETARY.ALTERED_CONSISTENCY_DIETS.id in permissions && <Grid item xs={12}>
          <FormTitle fieldAttributes={{ questionTitle: 'Altered consistency diets' }} />
          <FormTextAreaField
            fieldName={DIETARY.ALTERED_CONSISTENCY_DIETS.fieldName}
            focusedField={focusedField}
            setFocusedField={setFocusedField}
            fieldAttributes={{ isEditable: permissions[DIETARY.ALTERED_CONSISTENCY_DIETS.id] }}
          />
        </Grid>}

        {DIETARY.THERAPEUTIC_RESTRICTIONS.id in permissions && <Grid item xs={12}>
          <FormTitle fieldAttributes={{ questionTitle: 'Therapeutic restrictions' }} />
          <FormTextAreaField
            fieldName={DIETARY.THERAPEUTIC_RESTRICTIONS.fieldName}
            focusedField={focusedField}
            setFocusedField={setFocusedField}
            fieldAttributes={{ isEditable: permissions[DIETARY.THERAPEUTIC_RESTRICTIONS.id] }}
          />
        </Grid>}

        {DIETARY.DIETARY_SUPPLEMENTS.id in permissions && <Grid item xs={12}>
          <FormTitle fieldAttributes={{ questionTitle: 'Dietary supplements' }} />
          <FormTextAreaField
            fieldName={DIETARY.DIETARY_SUPPLEMENTS.fieldName}
            focusedField={focusedField}
            setFocusedField={setFocusedField}
            fieldAttributes={{ isEditable: permissions[DIETARY.DIETARY_SUPPLEMENTS.id] }}
          />
        </Grid>}

      </Grid>
    </Card>
};